import React, { useContext } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import ContentContainer from './ContentContainer';
import { QuickApplicationStatus } from '../../../../constants/quickApplicationConstants';
import { SortField } from '../Sort';
import SortableColumn from './SortableColumn';
import { StateContext } from '../../reports/components/StateContext';
import ApplicationActions from './ApplicationActions';
import { getApplicationViewData } from './util';

const CompleteContent = () => {
  const { sort, onSortChange } = useContext(StateContext);
  return (
    <ContentContainer
      col={5}
      status={QuickApplicationStatus.Completed}
      renderHeader={() => (
        <TableRow>
          <SortableColumn column={SortField.Id} onSortChange={onSortChange} sort={sort}>
            № заявления
          </SortableColumn>
          <SortableColumn column={SortField.Name} onSortChange={onSortChange} sort={sort}>
            Организация / ФИО
          </SortableColumn>
          <TableCell>Сколько осталось поездок</TableCell>
          <TableCell>Сколько всего поездок</TableCell>
          <TableCell align="right">Действие</TableCell>
        </TableRow>
      )}
      renderBody={(items, user) => {
        return items.map(item => {
          const viewData = getApplicationViewData(item, QuickApplicationStatus.Completed, user);
          return (
            <TableRow key={viewData.id}>
              <TableCell>{viewData.appNumber}</TableCell>
              <TableCell>{viewData.userName}</TableCell>
              <TableCell>{viewData.runsLeft}</TableCell>
              <TableCell>{viewData.runsTotal}</TableCell>
              <TableCell align="right" className="nowrap">
                <ApplicationActions user={user} item={item} />
              </TableCell>
            </TableRow>
          );
        });
      }}
    />
  );
};

export default CompleteContent;
